import { IResult } from '../../../ts/ServerApi/types/IResponse';
import { Request } from '../../../ts/ServerApi/requests/Request';

export interface IEnableWorkbookAccelerationParams {
  targetIds: string[];
  scheduleId: string;
}

export class EnableWorkbookAccelerationRequest extends Request<IEnableWorkbookAccelerationParams, IResult> {
  constructor(params: IEnableWorkbookAccelerationParams) {
    super('enableWorkbookAcceleration', params);
  }
}
